
import React, { Fragment as F,
  createContext,
  useContext, useEffect, useState,
} from 'react'

import FintegrationResultsModal from './FintegrationResultsModal'
import FintegrationSearchModal from './FintegrationSearchModal'

import {
  C,
  defaultFintegrationQueryTmpl,
  logg, loggt,
  useApiRouter,
} from '$shared'
import { AppCtx } from "$src/App"


const FintegrationCtx = createContext({
  sortedResults: [],
})

const defaultFintegrationOpts = {
  ATM_Network: [],
  billPayVendor: [],
  Business_Online_Vendor: [],
  Check_Vendor: [],
  Commercial_LOS: [],
  Content_Management_System: [],
  coreVendor: [],
  creditCardIssuer: [],
  creditCardType: [],
  creditProcessor: [],
  debitCardType: [],
  debitProcessor: [],
  merchantServicesProcessor: [],
  mobileVendor: [],
  Online_Auto_Loan_Origination_System: [],
  Online_Mortgage_Loan_Origination_System: [],
  Online_New_Account_Opening: [],
  Online_Vendor: [],
  P2P_Vendor: [],
  Rewards: [],
  Web_Live_Chat_Vendor: [],
}

/**
 * FintegrationProvider
**/
const FintegrationProvider = ({ children, ...props }) => {


  /* ctx */

  const apiRouter = useApiRouter()

  const {
    jwtToken,
    loading, setLoading,
  } = useContext(AppCtx)


  /* state */
  const [ fintegrationOpts, setFintegrationOpts ] = useState(defaultFintegrationOpts)
  const [ fintegrationResults, setFintegrationResults ] = useState([])
  const [ fintegrationResultsModalOpen, setFintegrationResultsModalOpen ] = useState(false)
  const [ fintegrationSearchModalOpen,  setFintegrationSearchModalOpen  ] = useState(false)
  const [ labels, setLabels ] = useState([])
  const [ results, setResults ] = useState([])
  const [ resultsTitle, setResultsTitle ] = useState(null)

  const [ rssd, setRssd ] = useState(null)
  // const [ bank, setBank ] = useState({})
  // const [ selectedBanks, setSelectedBanks ] = useState({})
  const [ sortedResults, setSortedResults ] = useState([])
  const [ query, setQuery ] = useState(JSON.parse(JSON.stringify(defaultFintegrationQueryTmpl)))


  /* methods */

  return <FintegrationCtx.Provider value={{
    fintegrationOpts,             setFintegrationOpts,
    fintegrationResults,          setFintegrationResults,
    fintegrationResultsModalOpen, setFintegrationResultsModalOpen,
    fintegrationSearchModalOpen,  setFintegrationSearchModalOpen,
    labels,        setLabels,
    query,         setQuery,
    results,       setResults,
    resultsTitle,  setResultsTitle,
    rssd,          setRssd,
    sortedResults, setSortedResults,
  }}>{ children }</FintegrationCtx.Provider>
}

export {
  defaultFintegrationOpts,
  FintegrationCtx,
  FintegrationProvider,
  FintegrationResultsModal,
  FintegrationSearchModal,
}